export default "__VITE_ASSET__82a699c5__"